import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image';


export const harnessImage = (
    <StaticQuery
        query={graphql`
            query HarnessImage {
                file(relativePath: { eq: "gear-box.png" }) {
                    childImageSharp {
                        fluid(maxWidth: 475) {
                            ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                    }
                }
            }
        `}
    >
        {data => <Img fluid={data.file.childImageSharp.fluid} className="box-links__gear-image" alt="Medium and Tiny Tearrible" />}
    </StaticQuery>
)
